export const sitePages = [
  {
    text: "Page d'accueil",
    value: "/",
  },
  {
    text: "Page Projets",
    value: "/projets",
  },
  {
    text: "Page Actualités",
    value: "/actualites",
  },
  {
    text: "Page Carrières",
    value: "/carrieres",
  },

  {
    text: "Page Contact",
    value: "/contact",
  },
  {
    text: "Page Mentions légales",
    value: "/mentions-legales",
  },
];
